import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { ExampleChart } from 'src/components/ExampleChart';
import { BizChartsBar } from './BizChartsBar';
import { BizChartsDoughnut } from './BizChartsDoughnut';
import { BizChartsLine } from './BizChartsLine';
import { BizChartsPie } from './BizChartsPie';
import { BizChartsRadar } from './BizChartsRadar';

const bizChartsBarCode = require('!!raw-loader!./BizChartsBar').default;
const bizChartsLineCode = require('!!raw-loader!./BizChartsLine').default;
const bizChartsPieCode = require('!!raw-loader!./BizChartsPie').default;
const bizChartsDoughnutCode = require('!!raw-loader!./BizChartsDoughnut').default;
const bizChartsRadarCode = require('!!raw-loader!./BizChartsRadar').default;

// #region -------------- Interfaces --------------------------------------------------------------

interface IProps { }

// #endregion

// #region -------------- Component ---------------------------------------------------------------

export class BizCharts extends React.PureComponent<IProps> {
  public render() {
    return (
      <div>
        <Tabs id='pd-examples-dashboard-tabs'
          className='pd-tabs pd-examples-dashboard-tabs' mountOnEnter={true}>
          <Tab key={0}
            eventKey={0} title='Bar Chart' tabClassName='pd-tab'>
            <ExampleChart component={<BizChartsBar />} code={bizChartsBarCode} />
          </Tab>
          <Tab key={1}
            eventKey={1} title='Line Chart' tabClassName='pd-tab'>
            <ExampleChart component={<BizChartsLine />} code={bizChartsLineCode} />
          </Tab>
          <Tab key={2}
            eventKey={2} title='Pie Chart' tabClassName='pd-tab'>
            <ExampleChart component={<BizChartsPie />} code={bizChartsPieCode} />
          </Tab>
          <Tab key={3}
            eventKey={3} title='Doughnut Chart' tabClassName='pd-tab'>
            <ExampleChart component={<BizChartsDoughnut />} code={bizChartsDoughnutCode} />
          </Tab>
          <Tab key={4}
            eventKey={4} title='Radar Chart' tabClassName='pd-tab'>
            <ExampleChart component={<BizChartsRadar />} code={bizChartsRadarCode} />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

// #endregion
